module.exports = "/packs/step3_sp-37ecbe6d575d75592d7111f26affbfae.png";